import React from "react";
import { Github, Twitter, Linkedin, Mail, Play, Globe } from "lucide-react";

const Footer = () => {
    return (
        <footer className="bg-black text-gray-400 py-16 px-4 md:px-12 border-t border-white/5">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
                {/* Brand Section */}
                <div className="space-y-6">
                    <div className="flex items-center space-x-2">
                        <h2 className="text-red-600 text-2xl font-black tracking-tighter">FLIXFUSION</h2>
                    </div>
                    <p className="text-sm leading-relaxed">
                        Ultimate cinematic experience powered by AI. Discover, explore, and immerse yourself in the world of movies.
                    </p>
                    <div className="flex space-x-4">
                        <button type="button" className="hover:text-red-600 transition-colors"><Twitter size={20} /></button>
                        <button type="button" className="hover:text-red-600 transition-colors"><Github size={20} /></button>
                        <button type="button" className="hover:text-red-600 transition-colors"><Linkedin size={20} /></button>
                    </div>
                </div>

                {/* Explore Links */}
                <div>
                    <h3 className="text-white font-bold mb-6">Explore</h3>
                    <ul className="space-y-4 text-sm">
                        <li><button type="button" className="hover:text-white transition-colors">Popular Movies</button></li>
                        <li><button type="button" className="hover:text-white transition-colors">AI Recommendations</button></li>
                        <li><button type="button" className="hover:text-white transition-colors">Trending Now</button></li>
                        <li><button type="button" className="hover:text-white transition-colors">New Releases</button></li>
                    </ul>
                </div>

                {/* Support Links */}
                <div>
                    <h3 className="text-white font-bold mb-6">Support</h3>
                    <ul className="space-y-4 text-sm">
                        <li><button type="button" className="hover:text-white transition-colors">Help Center</button></li>
                        <li><button type="button" className="hover:text-white transition-colors">Account Details</button></li>
                        <li><button type="button" className="hover:text-white transition-colors">Privacy Policy</button></li>
                        <li><button type="button" className="hover:text-white transition-colors">Terms of Service</button></li>
                    </ul>
                </div>

                {/* Newsletter */}
                <div className="space-y-6">
                    <h3 className="text-white font-bold">Stay Updated</h3>
                    <p className="text-sm">Get the latest movie updates and AI features delivered to your inbox.</p>
                    <div className="flex">
                        <input
                            type="email"
                            placeholder="Email address"
                            className="bg-white/5 border border-white/10 rounded-l-lg px-4 py-2 text-sm w-full focus:outline-none focus:border-red-600 transition-colors"
                        />
                        <button type="button" className="bg-red-600 text-white rounded-r-lg px-4 py-2 hover:bg-red-700 transition-colors">
                            <Mail size={18} />
                        </button>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                <p className="text-xs">© 2026 FLIXFUSION. Inspired by Netflix. Built with Gemini AI.</p>
                <div className="flex items-center space-x-6 text-xs">
                    <div className="flex items-center space-x-1 cursor-pointer hover:text-white">
                        <Globe size={14} />
                        <span>English</span>
                    </div>
                    <div className="flex items-center space-x-1 cursor-pointer hover:text-white">
                        <Play size={14} />
                        <span>App Store</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
